import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { meetingsApi } from '../api';

const statusInfo = {
  aufgenommen: { label: '📁 Aufgenommen', color: '#64748b' },
  hochgeladen: { label: '⬆️ Hochgeladen', color: '#0ea5e9' },
  transkribiert_laufend: { label: '⏳ Transkribiert...', color: '#f59e0b' },
  transkribiert: { label: '📝 Transkribiert', color: '#8b5cf6' },
  analysiert: { label: '🤖 Analysiert', color: '#6366f1' },
  fertig: { label: '✅ Fertig', color: '#10b981' },
  fehler: { label: '❌ Fehler', color: '#ef4444' },
};

export default function MeetingsPage() {
  const [meetings, setMeetings] = useState([]);
  const [showToken, setShowToken] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    meetingsApi.list().then(res => setMeetings(res.data));
    const interval = setInterval(() => {
      meetingsApi.list().then(res => setMeetings(res.data));
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#0f172a', padding: 16 }}>
      <div style={{ maxWidth: 600, margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <div>
            <h1 style={{ color: '#f1f5f9', fontSize: 22, fontWeight: 700 }}>🎙️ Meeting Notes</h1>
            <p style={{ color: '#64748b', fontSize: 12 }}>{meetings.length} Meeting(s)</p>
          </div>
          <button onClick={() => navigate('/admin')} style={{ background: '#1e293b', color: '#64748b', border: '1px solid #334155', padding: '10px 12px', borderRadius: 8, cursor: 'pointer', fontSize: 14, marginRight: 8 }}>⚙️</button>
          <button onClick={() => navigate('/neu')} style={{ background: '#6366f1', color: 'white', border: 'none', padding: '10px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>
            + Neues Meeting
          </button>
        </div>

        {meetings.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 60, color: '#64748b' }}>
            <div style={{ fontSize: 56, marginBottom: 12 }}>🎙️</div>
            <p>Noch keine Meetings</p>
            <p style={{ fontSize: 13, marginTop: 8 }}>Klicke "+ Neues Meeting" um zu starten</p>
          </div>
        ) : (
          meetings.map(m => {
            const info = statusInfo[m.status] || statusInfo.aufgenommen;
            const datum = new Date(m.datum).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
            return (
              <div key={m.id} onClick={() => navigate(`/meeting/${m.id}`)}
                style={{ background: '#1e293b', borderRadius: 12, padding: 16, marginBottom: 12, cursor: 'pointer', border: '1px solid #334155' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ color: '#f1f5f9', fontWeight: 700, fontSize: 16, marginBottom: 4 }}>{m.titel}</div>
                    <div style={{ color: '#64748b', fontSize: 12 }}>📅 {datum}</div>
                    {m.teilnehmer && <div style={{ color: '#64748b', fontSize: 12, marginTop: 2 }}>👥 {m.teilnehmer}</div>}
                    {m.dauer_sekunden && <div style={{ color: '#64748b', fontSize: 12, marginTop: 2 }}>⏱️ {Math.round(m.dauer_sekunden / 60)} Min.</div>}
                  </div>
                  <span style={{ background: info.color + '22', color: info.color, padding: '4px 10px', borderRadius: 8, fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap' }}>
                    {info.label}
                  </span>
                </div>
              </div>
            );
          })
        )}

        {showToken && (
          <div style={{ background: '#1e293b', borderRadius: 12, padding: 16, marginBottom: 16 }}>
            <div style={{ color: '#94a3b8', fontSize: 12, marginBottom: 8 }}>🔑 Dein Token für iOS Shortcut:</div>
            <div style={{ background: '#0f172a', borderRadius: 8, padding: 10, wordBreak: 'break-all', fontSize: 11, color: '#7dd3fc', fontFamily: 'monospace', userSelect: 'all' }}>
              {localStorage.getItem('meetingnotes_token')}
            </div>
            <div style={{ color: '#64748b', fontSize: 11, marginTop: 8 }}>👆 Text antippen und gesamten Text auswählen zum Kopieren</div>
          </div>
        )}
        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <button onClick={() => setShowToken(!showToken)}
            style={{ background: 'none', border: 'none', color: '#64748b', cursor: 'pointer', fontSize: 13, marginRight: 12 }}>
            🔑 Token anzeigen
          </button>
          <button onClick={() => { localStorage.removeItem('meetingnotes_token'); window.location.href = '/login'; }}
            style={{ background: 'none', border: 'none', color: '#64748b', cursor: 'pointer', fontSize: 13 }}>
            Abmelden
          </button>
        </div>
      </div>
    </div>
  );
}
